import React from "react";
import { useTab } from "../../contexts/tab";
import classNames from "classnames";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/auth";

export default function TabPagination() {
  const [{ tabData, isShowPagination }, { setTabData }] = useTab();
  const [{ activeUser }] = useAuth();

  const fetchTabData = async (url) => {
    setTabData(null);
    if (!url) return null;
    try {
      const res = await fetch(url, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${activeUser?.remember_token}`,
        },
      });

      const data = await res.json();

      if (res.status === 401) {
        toast.error(data.message);
        document.cookie =
          "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        return 0;
      }

      if (data.status) {
        setTabData(JSON.parse(data.data));
      } else {
        setTabData(null);
      }
    } catch (error) {
      setTabData(null);
      console.error("TabProvider:: api calling fail =>", error);
    }
  };

  if (!tabData || !isShowPagination) return null;

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-4 sm:px-6">
        <div className="flex flex-1 items-center justify-between">
          <div>
            <p className="text-sm text-gray-700">
              Showing <span className="font-medium">{tabData.from}</span> to{" "}
              <span className="font-medium">{tabData.to}</span> of{" "}
              <span className="font-medium">{tabData.total}</span> results
            </p>
          </div>
          <div>
            <nav
              className="isolate inline-flex -space-x-px rounded-md shadow-sm"
              aria-label="Pagination"
            >
              {tabData.links.map(({ active, label, url }, i) => {
                return (
                  <button
                    key={url ? url + label : i}
                    disabled={!url}
                    onClick={() => fetchTabData(url)}
                    className={classNames(
                      "border px-2 py-1",
                      active && "bg-orange text-white"
                    )}
                  >
                    {i == 0 ? "<" : i == tabData.links.length - 1 ? ">" : label}
                  </button>
                );
              })}
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
}
